import React from "react";
import { motion } from "framer-motion";
import { Song } from "../../types/song";

interface EmbeddedPlayerProps {
  song: Song;
}

// Generic embedded-player section: renders whatever ready-to-embed URL the
// admin supplies (usually a YouTube embed link, but any embeddable provider
// works — no platform-specific parsing needed since the field is already a
// direct iframe src). Hides entirely when embeddedPlayerUrl isn't set.
const EmbeddedPlayer: React.FC<EmbeddedPlayerProps> = ({ song }) => {
  const embedUrl = song.embeddedPlayerUrl?.trim();
  if (!embedUrl) return null;

  return (
    <section id="song-player" className="py-10 px-6 bg-white">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="max-w-2xl mx-auto"
      >
        <div className="relative rounded-2xl overflow-hidden shadow-xl" style={{ paddingBottom: "56.25%", height: 0 }}>
          <iframe
            title={`${song.title} player`}
            src={embedUrl}
            loading="lazy"
            frameBorder="0"
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            allowFullScreen
            className="absolute top-0 left-0 w-full h-full"
          />
        </div>
      </motion.div>
    </section>
  );
};

export default EmbeddedPlayer;
